import React from 'react';
import { ProductTag } from './ProductTag';
import { getIconClassNameByFlag } from '../utils/phase';
import { Tooltip } from './Tooltip';
import ReactTooltip from 'react-tooltip';

const MAX_TAG_COUNT_TO_DISPLAY = 3;

export const Product = ({
    name,
    amount,
    id,
    flags,
    imageUrl,
    onDecrementProduct,
    onIncrementProduct,
    onProductAmountChange,
    tags,
    productUrl,
    hasPhaseStepMealsCompleted,
    remainingProductsToCompleteCount,
    isIncrementButtonDisabled,
    disabledIncrementButtonText,
    productNotAvailableButtonText,
    availability,
}) => {
    // Zakomentovaná část kódu řeší zamezení vepsat do inputu hodnotu, která by přesahovala v součtu max počet jídel,
    // nyní zakomentováno, protože by bylo třeba poladit UX část.
    // const inputRef = useRef();
    // const [oldInputValue, setOldInputValue] = useState();
    const iconFlags = flags && flags.length > 0 ? [...flags] : [];
    // if (iconFlags.length > 1) {
    //     iconFlags.splice(Math.ceil(iconFlags.length / 2), 0, 'separator');
    // }

    // const onKeyDown = () => {
    //     const value = parseInt(inputRef.current.value);

    //     if (!value || (value <= remainingProductsToCompleteCount - amount && value >= 0)) {
    //         setOldInputValue(value);
    //     }
    // };

    // const onKeyUp = () => {
    //     const value = parseInt(inputRef.current.value);

    //     if (!value || (value <= remainingProductsToCompleteCount - amount && value >= 0)) {
    //         return;
    //     }

    //     inputRef.current.value = oldInputValue;
    //     onProductAmountChange(id, oldInputValue);
    // };
    const inputMax = remainingProductsToCompleteCount + amount;

    const isMaxProductStockAmountReached = availability === 0;
    const hasAmountExceedAvailability = availability < 0;

    const isProductIncrementable =
        !hasPhaseStepMealsCompleted &&
        !isIncrementButtonDisabled &&
        !isMaxProductStockAmountReached &&
        !hasAmountExceedAvailability;

    // Na tlačítko nemůžeme použít disable, kvůli tooltipu => odchycení při kliknutí
    const onIncrementClicked = () => {
        if (isProductIncrementable) {
            onIncrementProduct();
        }
    };

    return (
        <div className="product">
            <ReactTooltip />

            <div className="product__image-wrapper">
                <a href={productUrl} target="_blank" rel="noreferrer">
                    <img className="product__image" src={imageUrl} alt="product image" />
                </a>
                {amount > 0 ? (
                    <div className="product__image-overlay">
                        <img src="../../../../img/theme/icons/30-cart.white.png" alt="cart icon" />
                    </div>
                ) : null}
            </div>
            <div className="product__tags">
                {tags && tags.length > 0
                    ? tags.map((tag, index) => {
                          const hasProductTagExceedLimit = index + 1 > MAX_TAG_COUNT_TO_DISPLAY;

                          return hasProductTagExceedLimit ? null : (
                              <ProductTag
                                  key={tag.id}
                                  name={tag.name}
                                  icon={tag.icon}
                                  fontColor={tag.fontColor}
                                  backgroundColor={tag.backgroundColor}
                              />
                          );
                      })
                    : null}
            </div>
            <a href={productUrl} target="_blank" rel="noreferrer">
                <div className="product__title">{name}</div>
            </a>
            <div className="product__footer">
                <div className="icons-wrapper">
                    {iconFlags && iconFlags.length > 0
                        ? iconFlags.map((flag, index) => {
                              const iconName = getIconClassNameByFlag(flag.title);
                              // if (flag === 'separator') {
                              //     return (
                              //         <span key={index} className="icon-separator">
                              //             nebo
                              //         </span>
                              //     );
                              // }
                              return iconName ? (
                                  <Tooltip key={index} text={flag.description}>
                                      <img src={`../../../../img/theme/icons/${iconName}`} alt={flag.description} />
                                  </Tooltip>
                              ) : null;
                          })
                        : null}
                </div>
                <span className="quantity-wrapper incrementable--sm incrementable">
                    <button
                        type="button"
                        className="incrementable__control incrementable__control--dec"
                        onClick={onDecrementProduct}
                    >
                        <i className="fas fa-minus" />
                    </button>
                    <input
                        name="quantity"
                        type="number"
                        className={`incrementable__input quantity${
                            hasAmountExceedAvailability ? ' quantity--exceeded' : ''
                        }${hasPhaseStepMealsCompleted ? ' incrementable__input--disabled' : ''}`}
                        value={amount}
                        min={0}
                        max={inputMax ? inputMax : undefined}
                        onChange={(event) => onProductAmountChange(id, Math.abs(event.target.value), name)}
                        // onKeyDown={onKeyDown}
                        // onKeyUp={onKeyUp}
                        // ref={inputRef}
                        disabled
                    />
                    <button
                        type="button"
                        className={`incrementable__control incrementable__control--inc${
                            !isProductIncrementable ? ' incrementable__control--inc--disabled' : ''
                        }`}
                        onClick={onIncrementClicked}
                        // disabled={hasPhaseStepMealsCompleted || isIncrementButtonDisabled}
                        data-tip={
                            isMaxProductStockAmountReached || hasAmountExceedAvailability
                                ? productNotAvailableButtonText
                                : disabledIncrementButtonText
                        }
                        data-tip-disable={isProductIncrementable}
                    >
                        <i className="fas fa-plus" />
                    </button>
                </span>
            </div>
        </div>
    );
};
